<script>
import Vue from 'vue'
import NumberFormat from '@shared/plugins/NumberFormat'
import DateFormat from '@shared/plugins/DateFormat'
import i18n from '@shared/module/i18n'
import UserMixin from '@shared/mixins/UserMixin'
import SessionMixin from '@shared/mixins/SessionMixin'
import { deepFreeze } from '@shared/utils/objectUtils'
import AnalyticsMixin from '@shared/mixins/AnalyticsMixin'
import store from '@shared/store'

export default {
  mixins: [UserMixin, SessionMixin, AnalyticsMixin],
  methods: {
    loadAppResources(finalize) {
      return this.$http.get('/api/configuration')
          .then(this.setConfiguration)
          .then(this.restoreUserSession)
          .then(this.attachGlobalErrorsInterceptor)
          .then(this.initializeUserTracking)
          .then(finalize)
          .catch(() => {
            this.loadingFailed = true
            setTimeout(this.loadAppResources, 3000)
          })
    },
    setConfiguration(response) {
      const configuration = deepFreeze(response.data)
      Vue.use(NumberFormat, { configurationSupplier: () => configuration })
      Vue.use(DateFormat)
      Vue.prototype.$configuration = configuration
    },
    attachGlobalErrorsInterceptor() {
      this.$http.interceptors.response.use(
          (response) => response,
          (error) => {
            const response = error.response
            if (response) {
              if (response.status === 500) {
                Vue.$errorToast(i18n.t('errors.technical.title'), i18n.t('errors.technical.content'))
              }
              if (response.status === 403) {
                Vue.$errorToast(i18n.t('errors.notAuthorized.title'), i18n.t('errors.notAuthorized.content'))
                this.logOut()
              }
              if (response.status === 401) {
                this.logOut()
              }
              if (response.status === 413) {
                this.logOut()
              }
            }
            return Promise.reject(error)
          }
      )
    },
    initializeUserTracking() {
      if (store.state.currentUser) {
        this.logUserSignedIn(store.state.currentUser.pin)
      }
    }
  }
}
</script>
